module.exports = __webpack_public_path__ + "img/weather_bg_small.44cc2ee4.png";